import React, { useState } from 'react'
import LoadingButton from 'components/ui/general/buttons/LoadingButton'
import { useCreateFileType, useDeleteFileType, useListFileType, useUpdateFileType } from 'graphQLHooks/dataManager/dataManagerHooks'
import { message, Popover, Skeleton, Table } from 'antd'
import { cloneDeep, isEmpty } from 'lodash'
import ExpandMenuIcon from 'components/ui/general/icons/ExpandMenuIcon'
import './DataFiles.scss'
import CreateFilesModal from 'components/ui/dataEntry/other/CreateFilesModal'
import { utilityService } from 'services/UtilityService'
import userMessages from 'constants/messages'
import DeleteFileTypeModal from 'components/ui/dataEntry/other/DeleteFileTypeModal'

const actionMenuOptions = [
  {
    type: 'edit',
    name: 'Edit'
  },
  {
    type: 'delete',
    name: 'Delete'
  }
]

const DataFiles = ({ project, refetchAudits }) => {
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false)
  const [selectedRowDetails, setSelectedRowDetails] = useState(null)
  const handleSelectedRowDetails = (details) => setSelectedRowDetails(details)
  const [isCreateFileModalOpen, setCreateFileModalOpen] = useState(false)
  const [filesTableToggleMenuItems, setFilesTableToggleMenuItems] = useState({})
  const handleOpenCloseToggleMenu = (rowId, flag) => {
    setFilesTableToggleMenuItems(prevState => {
      let currentData = cloneDeep(prevState)
      currentData[rowId] = flag
      return currentData
    })
  }
  const toggleActionMenu = (selectedOption) => {
    const isEditAction = selectedOption.type === 'edit'
    const isDeleteAction = selectedOption.type === 'delete'
    if (isEditAction) {
      setCreateFileModalOpen(true)
    } else if (isDeleteAction) {
      setIsDeleteFolderModalOpen(true)
    }
  }

  const {
    data: fileList,
    loading: isFileListLoading,
    refetch: refetchFileList
  } = useListFileType({
    variables: {
      module: '',
      project,
      limit: 999,
      nextToken: ''
    }
  })

  const [
    createFileType,
    {
      loading: isCreateFileTypeLoading
    }
  ] = useCreateFileType({
    onError: (errorResponse) => {
      utilityService.handleError(errorResponse)
    },
    onCompleted: () => {
      message.success(userMessages.CREATE_FILE_TYPE_SUCCESS)
      refetchFileList()
      setCreateFileModalOpen(false)
      refetchAudits()
    }
  })

  const [
    updateFileType,
    {
      loading: isUpdateFileTypeLoading
    }
  ] = useUpdateFileType({
    onError: (errorResponse) => {
      utilityService.handleError(errorResponse)
    },
    onCompleted: () => {
      message.success(userMessages.UPDATE_FILE_TYPE_SUCCESS)
      refetchFileList()
      setCreateFileModalOpen(false)
      handleSelectedRowDetails(null)
      refetchAudits()
    }
  })

  const [
    deleteFileType,
    {
      loading: isDeleteFileTypeLoading
    }
  ] = useDeleteFileType({
    onError: (errorResponse) => {
      utilityService.handleError(errorResponse)
    },
    onCompleted: () => {
      message.success(userMessages.DELETE_FILE_TYPE_SUCCESS)
      refetchFileList()
      setCreateFileModalOpen(false)
    }
  })

  const filesTableColumn = [
    {
      title: 'Title',
      dataIndex: 'name',
      key: 'name'
      // width: '23%'
    },
    {
      title: 'Extension',
      dataIndex: 'extension',
      key: 'extension'
      // width: '5%'
    },
    {
      title: 'Status',
      dataIndex: 'isEnabled',
      key: 'isEnabled',
      render: (activeFlag) => (
        <> {activeFlag ? 'Active' : 'Inactive'}</>
      )
      // width: '5%'
    },
    {
      title: '# of files',
      dataIndex: 'usageCount',
      key: 'usageCount'
      // render: (activeFlag) => (
      //   <> {activeFlag ? 'Active' : 'Inactive'}</>
      // )
      // width: '5%'
    },
    {
      width: '7%',
      title: '',
      key: 'action',
      render: (details) => {
        const rowId = details?.id
        const hasZeroUsageCount = details.usageCount === 0
        return (
          <div className='option-list' id='option-list-container'>
            <Popover
              content={
                actionMenuOptions.map(item => {
                  // hide delete option if usage count is zero
                  if (!hasZeroUsageCount && item.type === 'delete') return null
                  return (
                    <p
                      onClick={() => {
                        toggleActionMenu(item)
                        handleSelectedRowDetails(details)
                        handleOpenCloseToggleMenu(rowId, false)
                      }}
                    >
                      {item.name}
                    </p>
                  )
                })
              }
              title={null}
              trigger='click'
              visible={filesTableToggleMenuItems?.[rowId]}
              onVisibleChange={(flag) => handleOpenCloseToggleMenu(rowId, flag)}
              placement='left'
            >
              <div><ExpandMenuIcon /></div>
            </Popover>
          </div>
        )
      }
    }
  ]

  const loadingTable = [
    {
      title: '',
      dataIndex: '1',
      key: 'name',
      width: '100%',
      render: () => {
        return <Skeleton avatar={false} title={false} paragraph={{ rows: 1 }} active />
      }
    }
  ]

  const isEditMode = !isEmpty(selectedRowDetails)

  return (
    <div className='data-files'>
      <div className='files-table-wrapper'>
        {
          isFileListLoading
            ? (
              <Table
                columns={loadingTable}
                dataSource={new Array(10).fill().map((file, index) => {
                  return {
                    dummy: index
                  }
                })}
                pagination={false}
                className='loading-table'
              />
            )
            : (
              <Table
                columns={filesTableColumn}
                dataSource={fileList?.listFileType?.items}
                pagination={false}
                scroll={{ y: 'calc(100vh - 280px)' }}
                className='enhance-table'
                loading={isFileListLoading}
              />
            )
        }
        {console.log('fileList?.listFileType?.items', fileList?.listFileType?.items)}
      </div>
      <LoadingButton
        buttonText='Create'
        onClick={() => {
          setCreateFileModalOpen(true)
        }}
        buttonClass='create-file-button'
      />
      <DeleteFileTypeModal
        visible={isDeleteFolderModalOpen}
        onOk={() => {
          deleteFileType({
            variables: {
              id: selectedRowDetails?.id,
              project
            },
            onCompleted: () => {
              refetchFileList()
              setIsDeleteFolderModalOpen(false)
              handleSelectedRowDetails(null)
              message.success(userMessages.UPDATE_FILE_TYPE_SUCCESS)
              refetchAudits()
            }
          })
        }}
        onCancel={() => {
          setIsDeleteFolderModalOpen(false)
          handleSelectedRowDetails(null)
        }}
        loading={isDeleteFileTypeLoading}
      />
      <CreateFilesModal
        isEditMode={isEditMode}
        visible={isCreateFileModalOpen}
        fieldData={selectedRowDetails}
        onOk={(formValues) => {
          if (isEditMode) {
            const {
              name,
              isEnabled
            } = formValues
            updateFileType({
              variables: {
                project,
                input: {
                  name,
                  id: selectedRowDetails.id,
                  isEnabled
                }
              }
            })
          } else {
            createFileType({
              variables: {
                project,
                input: formValues
              }
            })
          }
        }}
        onCancel={(resetForm) => {
          setCreateFileModalOpen(false)
          setTimeout(() => {
            handleSelectedRowDetails(null)
            resetForm()
          }, 350)
        }}
        loading={isCreateFileTypeLoading || isUpdateFileTypeLoading}
      />
    </div>
  )
}

export default DataFiles
